<script setup>
    import { ref, onMounted, watch  } from 'vue';
    import axios from 'axios';
    import VueDatePicker from '@vuepic/vue-datepicker';
    import { isValidIBAN } from 'ibantools';
    import Swal from 'sweetalert2';

    const submitResult = ref(null);
    const submitError = ref(null);
    const props = defineProps(['rechnungsempfaenger', 'teilnehmer','tarifnummer',
     'vertragsbeginn', 'laden_vertragsbeginn','vertragsende','vorname', 'name', 'firmennachzahler',
     'kartennummer', 'bemerkung', 'tarifbezeichnung', 'stammanlagennummer',
    'stammanlagenbezeichnung', 'wochenprogrammgueltigkeit', 'wochenprogrammnummer',
    'monatspauschale', 'nachzahltarif', 'ueberziehungsgebuehr',
    'rabattteilnehmer', 'gutschrift', 'bestpreismin',
    'bestpreismax', 'status', 'mindate', 'maxdate', 'rfid', 'charging_rate_id',
     'anrede','name1', 'name2', 'strasse', 'ort', 'plz', 'land', 'email', 'telefon1',   // Firmennachzahler daten
      'iban', 'zahlart', 'geburtsdatum', // Firmennachzahler daten
    'nutzergruppen','campaigns','dienstausweisnummer', 'campaign', 'show_nutzergruppe', 'nutzergruppe', 'danger', 'active', 'lost_nupsi_in_progress', 'needsladen']);


    const danger = ref(props.danger);
    const show_nutzergruppe = ref(props.show_nutzergruppe);
    const isActive = ref(props.active ? true : false);
    const nutzergruppenArray = ref([]);
    const campaigns = ref([]);
    const lost_nupsi_in_progress = ref(props.lost_nupsi_in_progress === "1" ? true : false);
    const needsLaden = Number(props.needsladen) === 1 ? true : false;

    onMounted(() => {
        nutzergruppenArray.value = JSON.parse(props.nutzergruppen);
        campaigns.value = JSON.parse(props.campaigns);
    });

    const isModalVisible = ref(false);
    const isLoading = ref(null);

    // Datepicker for start and end should be between the start and end of the contract
    const minDate = ref(formatDateJS(props.mindate));
    const maxDate = ref(formatDateJS(props.maxdate));

    // Data that is beeing prepared to be send
    const newTeilnehmerData = ref({
        Rechnungsempfaenger: props.rechnungsempfaenger,
        Teilnehmer: props.teilnehmer,
        Tarifnummer: props.tarifnummer,
        Vertragsbeginn :formatDateJS(props.vertragsbeginn),
        laden_vertragsbeginn : formatDateJS(props.laden_vertragsbeginn),
        Vertragsende:formatDateJS(props.vertragsende),
        Vorname: props.vorname,
        Name: props.name,
        Firmennachzahler: props.firmennachzahler,
        Kartennummer: props.kartennummer,
        rfid: props.rfid,
        charging_rate_id: props.charging_rate_id || '',
        Bemerkung: props.bemerkung,
        Tarifbezeichnung: props.tarifbezeichnung,
        Stammanlagennummer: props.stammanlagennummer,
        Stammanlagenbezeichnung: props.stammanlagenbezeichnung,
        Wochenprogrammgueltigkeit: props.wochenprogrammgueltigkeit,
        Wochenprogrammnummer: props.wochenprogrammnummer,
        Monatspauschale: props.monatspauschale,
        Nachzahltarif: props.nachzahltarif,
        Ueberziehungsgebuehr: props.ueberziehungsgebuehr,
        RabattTeilnehmer: props.rabattteilnehmer,
        Gutschrift: props.gutschrift,
        Bestpreismin: props.bestpreismin,
        Bestpreismax: props.bestpreismax,
        Status: (props.status == "") ? '0' : props.status,
        Anrede:props.anrede,Name1:props.name1, Name2:props.name2, Strasse:props.strasse, Ort:props.ort,// Firmennachzahler
        Plz:props.plz, Land:props.land, Email:props.email, Telefon1:props.telefon1,
        Iban:props.iban, Zahlart:props.zahlart, Geburtsdatum:formatDateJS(props.geburtsdatum),
        Nutzergruppe: (show_nutzergruppe.value ? ((props.nutzergruppe == "") ? '1001' : props.nutzergruppe) : ""),
        archiveChange: true,
        campaign: props.campaign,
        dienstausweisnummer: props.dienstausweisnummer,

    });

    const getShowNutzerGruppe = (tarifnummer) => {
        axios.get('/nutzergruppen/' + tarifnummer )
            .then(response => {
                if(response.data){
                    show_nutzergruppe.value = true;
                    newTeilnehmerData.value.Nutzergruppe = "1001";
                } else{
                    show_nutzergruppe.value = false;
                    newTeilnehmerData.value.Nutzergruppe = "";
                }
            })
            .catch(error => {
                 console.error(error);
            });
    };

    watch(() => newTeilnehmerData.value.Tarifnummer, (newVal) => {
        // check if the tarif to nutzergruppe relation exists. If not show the selection box for the user
        if (newVal.length > 0) {
            getShowNutzerGruppe(newVal);
        }
    });

    function formatDateJS( date){
       if( typeof(date) == "string" && date.length == 10 ){
            return date.substring(0,4)  + date.substring(4,7) +  date.substring(7) + "T00:00:00.000Z";

        } else
        if( typeof(date) != "string" || date.length != 8 ){
            return setStartDate()
        }
        return date.substring(0,4) + "-" + date.substring(4,6) + "-" + date.substring(6) + "T00:00:00.000Z";
    }

    function setStartDate(){
        const now = new Date();
        const day = now.getDate() < 10 ? "0"+now.getDate() : now.getDate();
        const month = now.getMonth()+1 < 10 ? "0"+(now.getMonth()+1) : now.getMonth()+1;
        const startDate = now.getFullYear() + '-' + month + '-' + day + "T00:00:00.000Z";
        return startDate;
    }

    const errorBanking = ref("");

    // when changing the invoice type, values should be reset
    function resetValues(){
        if(oldRechArt != newTeilnehmerData.value.RabattTeilnehmer){
            newTeilnehmerData.value.Bestpreismax = "";
            newTeilnehmerData.value.Bestpreismin = "";
            newTeilnehmerData.value.Gutschrift = "";
            oldRechArt = newTeilnehmerData.value.RabattTeilnehmer;
        }
    }

    var oldRechArt =  newTeilnehmerData.value.RabattTeilnehmer;

    // format the price data from the javascript before sending
    function formatPrice(){
        newTeilnehmerData.value.Bestpreismax = parseFloat((newTeilnehmerData.value.Bestpreismax).replaceAll(",", ".")).toString();
        newTeilnehmerData.value.Bestpreismin = parseFloat((newTeilnehmerData.value.Bestpreismin).replaceAll(",", ".")).toString();
        newTeilnehmerData.value.Gutschrift = parseFloat((newTeilnehmerData.value.Gutschrift).replaceAll(",", ".")).toString();
        if( newTeilnehmerData.value.Bestpreismax == "NaN"){
            newTeilnehmerData.value.Bestpreismax = "0"
        }
        if( newTeilnehmerData.value.Bestpreismin == "NaN"){
            newTeilnehmerData.value.Bestpreismin = "0"
        }
        if( newTeilnehmerData.value.Gutschrift == "NaN"){
            newTeilnehmerData.value.Gutschrift = "0"
        }
    }

    // function is called when the price input fields change.
    function changePoint(){
        newTeilnehmerData.value.Bestpreismin =  newTeilnehmerData.value.Bestpreismin.replaceAll('.', ',')
        newTeilnehmerData.value.Bestpreismax = newTeilnehmerData.value.Bestpreismax.replaceAll('.', ',')
        newTeilnehmerData.value.Gutschrift = newTeilnehmerData.value.Gutschrift.replaceAll('.', ',')
    }

    // helper function to stop error message
    function timeout(i){
        if(i == 1){
            document.getElementById("iban").classList.remove("is-invalid") ;
        }
        errorBanking.value = "";
    }

    async function submit() {
        isLoading.value = true;

        // If Tarifnummer is 84, ask for forced cancellation confirmation
        if (newTeilnehmerData.value.Tarifnummer == 84 && newTeilnehmerData.value.archiveChange)  {
            const result = await Swal.fire({
                title: "Zwangskündigung?",
                text: "Soll diese Kündigung als Zwangskündigung durchgeführt werden?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ja",
                cancelButtonText: "Nein"
            });
            // Set forced to true if confirmed, false otherwise.
            newTeilnehmerData.value.forced = result.isConfirmed;
        } else {
            // For any other tariff, forced is false
            newTeilnehmerData.value.forced = false;
        }

        // Continue with further validations (like IBAN, price formatting, etc.)
        if ( newTeilnehmerData.value.Firmennachzahler.length > 0 && newTeilnehmerData.value.Zahlart == "SEPA-Basislastschrift (CORE)"){
            if(!isValidIBAN( newTeilnehmerData.value.Iban)){
                document.getElementById("iban").classList.add("is-invalid");
                errorBanking.value += "iban";
                setTimeout(timeout, 2000, 1);
                isLoading.value = false;
                return;
            }
        }

        formatPrice();
        submitError.value = null;
        submitResult.value = null;

        newTeilnehmerData.value.Name1 = newTeilnehmerData.value.Name;
        newTeilnehmerData.value.Name2 = newTeilnehmerData.value.Vorname;

        await axios.put("teilnehmeredit/" + props.rechnungsempfaenger +  "/" + props.teilnehmer, newTeilnehmerData.value, { timeout: 60000 })
        .then(function (response) {
            submitResult.value = response;

            if(props.teilnehmer != newTeilnehmerData.value.Teilnehmer){
             window.location = "/teilnehmerliste";
            }

            let timeoutDuration = 3000;

            if(response !=null &&  response.data.status_code == 200){
                newTeilnehmerData.value.Monatspauschale = response.data.data.Monatspauschale;
                newTeilnehmerData.value.Tarifbezeichnung = response.data.data.Tarifbezeichnung;

                // Wenn ein Hinweis vorhanden ist (z.B. Lisy/AuthMedium), die Timeout-Zeit auf 15 Sekunden erhöhen
                if (response.data.data.Text != null && response.data.data.Text.length > 0){
                    timeoutDuration = 15000;
                }
            }

            isLoading.value = false;

            setTimeout(function(){
                submitError.value=null;
                submitResult.value=null;
                timeOutError.value = null;
            }, timeoutDuration);

        }).catch(function (error) {
            if(error.code === 'ECONNABORTED'){
                timeOutError.value = "Server konnte nicht erreicht werden! Überprüfen Sie Ihre Verbindung.";
            } else {
                submitError.value = error;
            }
            isLoading.value = false;
            setTimeout(function(){submitError.value=null; submitResult.value=null; timeOutError.value = null}, 3000);
        });
    }

    const timeOutError = ref(null);

    // get data form child component (TarifSelect)
    const handleData = (data) => {
        newTeilnehmerData.value.Tarifnummer =  data ;
        $('.modal').modal('hide');
    };

    async function clearFirmennachzahlerField(){
        Swal.fire({
            title: "Sind Sie sicher?",
            text: "Sind Sie sicher, dass Sie das Firmennahzahlerfeld leeren wollen?",
            icon: "warning",
            confirmButtonText: "Leeren",
            confirmButtonColor: "#e64942",
            showCancelButton: true,
            cancelButtonText: "Abbrechen",
            focusCancel: true,
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete("/firmennachzahler/clear/" + newTeilnehmerData.value.Rechnungsempfaenger
                + "/" + newTeilnehmerData.value.Teilnehmer)
                .then((data) => {
                    if (data.status === 200) {
                        Swal.fire({
                            title: "Erfolgreich",
                            text: "Firmennachzahler wurde geleert!",
                            icon: "success",
                        })
                        newTeilnehmerData.value.Firmennachzahler = "";
                        danger.value = "";
                    }
                })
            }
        }).catch((error) => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            });
        })
    }

    async function deleteFirmennachzahler(){
        Swal.fire({
            title: "Sind Sie sicher?",
            text: "Sind Sie sicher, dass Sie den Firmennahzahler löschen wollen?",
            icon: "warning",
            confirmButtonText: "Löschen",
            confirmButtonColor: "#e64942",
            showCancelButton: true,
            cancelButtonText: "Abbrechen",
            focusCancel: true,
            reverseButtons: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                await axios.delete("/firmennachzahler/remove/" + newTeilnehmerData.value.Rechnungsempfaenger
                    + "/" + newTeilnehmerData.value.Teilnehmer)
                .then((data) => {
                    if (data.status === 200) {
                        Swal.fire({
                            title: "Erfolgreich",
                            text: "Firmennachzahler wurde gelöscht!",
                            icon: "success",
                        })
                        newTeilnehmerData.value.Firmennachzahler = "";
                    }
                })
            }
        }).catch((error) => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            });
        })
    }
</script>


<template>
    <div class="grid-container">
        <div class="col">
            <form @submit.prevent="submit" class="teilnehmerEditForm">

                <!-- Bootstrap Grid System -->
                <div class="row g-3">

                    <div class="col-12 col-md-4">
                        <label for="rechnungsempfaenger_" >Rechnungsempfänger*</label>
                        <input id="rechnungsempfaenger_" readonly type="text" class="form-control"
                            v-model="newTeilnehmerData.Rechnungsempfaenger">
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="teilnehmer_" >Teilnehmer*</label>
                        <input id="teilnehmer_" readonly type="text" class="form-control"
                            v-model="newTeilnehmerData.Teilnehmer">
                    </div>

                    <div class="col-12 col-md-4 position-relative">
                        <label for="tarifnummer" >Tarifnummer*</label>
                        <input v-model="newTeilnehmerData.Tarifnummer" type="text" id="tarifnummer" name="tarifnummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined'),
                            }" />

                        <span data-bs-toggle="modal" data-bs-target=".modal"
                            @click="isModalVisible=true"
                            style="position: absolute; right: 25px; top: 30px; cursor: pointer;">
                            <i class="fas fa-edit" style="color: #a6a6a6;"></i>
                        </span>

                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Tarifnummer !== 'undefined')">
                            {{ submitError.response.data.Tarifnummer[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="tarifbezeichnung" >Tarifbezeichnung</label>
                        <input id="tarifbezeichnung" readonly type="text" class="form-control"
                            v-model="newTeilnehmerData.Tarifbezeichnung">
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="campaign" >Kampagne</label>

                        <select v-model="newTeilnehmerData.campaign" class="form-select" name="campaign" id="campaign">
                            <option value=""> -- keine -- </option>
                            <option :value=campaign v-for="campaign in campaigns">
                                {{ campaign }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-4" v-if="newTeilnehmerData.campaign">
                        <label for="dienstausweisnummer" >Dienstausweisnummer</label>
                        <input v-model="newTeilnehmerData.dienstausweisnummer" type="text" id="dienstausweisnummer"
                            name="dienstausweisnummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.dienstausweisnummer !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.dienstausweisnummer !== 'undefined')">
                            {{ submitError.response.data.dienstausweisnummer[0] }}
                        </div>
                    </div>

                    <!-- DatePickers -->
                    <div class="col-12 col-md-4">


                        <label >Vertragsbeginn*
                            <span v-if="!isActive && !lost_nupsi_in_progress" style="font-size:0.9em; font-weight: bold;">(noch nicht aktiviert)</span>
                        </label>
                        <VueDatePicker v-model="newTeilnehmerData.Vertragsbeginn" text-input format="dd.MM.yyyy"
                            locale="de" :enable-time-picker="false" selectText="Auswählen" cancelText="Abbrechen"
                            id="vertragsbeginn" :min-date="minDate" :max-date="maxDate"
                            :input-class="`form-control ${submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined' ? 'is-invalid' : ''}`"
                            utc />
                        <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response.data.Vertragsbeginn !== 'undefined')">
                            {{ submitError.response.data.Vertragsbeginn[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">


                        <label >Vertragsbeginn* (Laden)
                        </label>
                        <VueDatePicker v-model="newTeilnehmerData.laden_vertragsbeginn" text-input format="dd.MM.yyyy"
                            locale="de" :enable-time-picker="false" selectText="Auswählen" cancelText="Abbrechen"
                            id="laden_vertragsbeginn" :min-date="minDate" :max-date="maxDate"
                            :input-class="`form-control ${submitError !== null && typeof submitError.response.data.laden_vertragsbeginn !== 'undefined' ? 'is-invalid' : ''}`"
                            utc />
                        <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response.data.laden_vertragsbeginn !== 'undefined')">
                            {{ submitError.response.data.laden_vertragsbeginn[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label >Vertragsende*</label>
                        <VueDatePicker v-model="newTeilnehmerData.Vertragsende" text-input format="dd.MM.yyyy" locale="de"
                            :enable-time-picker="false" selectText="Auswählen" cancelText="Abbrechen" id="vertragsende"
                            :min-date="minDate" :max-date="maxDate"
                            :input-class="`form-control ${submitError !== null && typeof submitError.response.data.Vertragsende !== 'undefined' ? 'is-invalid' : ''}`"
                            utc />
                        <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response.data.Vertragsende !== 'undefined')">
                            {{ submitError.response.data.Vertragsende[0] }}
                        </div>
                    </div>

                    <!-- Names -->
                    <div class="col-12 col-md-4">
                        <label for="vorname" >Vorname</label>
                        <input v-model="newTeilnehmerData.Vorname" type="text" id="vorname" name="vorname"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Vorname !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Vorname !== 'undefined')">
                            {{ submitError.response.data.Vorname[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="name" >Name</label>
                        <input v-model="newTeilnehmerData.Name" type="text" id="name" name="name"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Name !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name !== 'undefined')">
                            {{ submitError.response.data.Name[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="kartennummer" >Kartennummer
                             <span v-if="lost_nupsi_in_progress" style="font-size:0.9em; font-weight: bold;">(Ersatz-Nupsi muss aktiviert werden!)</span>
                        </label>
                        <input :readonly="active" maxlength="9" v-model="newTeilnehmerData.Kartennummer" type="text" id="kartennummer" name="kartennummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Kartennummer !== 'undefined')">
                            {{ submitError.response.data.Kartennummer[0] }}
                        </div>
                    </div>

                    <!-- RFID -->
                    <div class="col-12 col-md-4">
                        <label for="rfid" >Rfid</label>
                        <div class="input-group">
                            <input id="rfid" type="text" class="form-control"
                                v-model="newTeilnehmerData.rfid"
                                :readonly="true"
                                :class="{ 'is-invalid': (submitError !== null && typeof submitError.response?.data?.rfid !== 'undefined') }" />
                        </div>
                        <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response?.data?.rfid !== 'undefined')">
                            {{ submitError.response.data.rfid[0] }}
                        </div>
                    </div>


                    <!-- Bemerkung -->
                    <div class="col-12 col-md-4">
                        <label for="bemerkung" >Bemerkung</label>
                        <input v-model="newTeilnehmerData.Bemerkung" type="text" id="bemerkung" name="bemerkung"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Bemerkung !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bemerkung !== 'undefined')">
                            {{ submitError.response.data.Bemerkung[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="stammanlagennummer" >Stammanlagennummer</label>
                        <input v-model="newTeilnehmerData.Stammanlagennummer" type="text" id="stammanlagennummer"
                            name="stammanlagennummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Stammanlagennummer !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Stammanlagennummer !== 'undefined')">
                            {{ submitError.response.data.Stammanlagennummer[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="stammanlagenbezeichnung" >Stammanlagenbezeichnung</label>
                        <input v-model="newTeilnehmerData.Stammanlagenbezeichnung" type="text" id="stammanlagenbezeichnung"
                            name="stammanlagenbezeichnung"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Stammanlagenbezeichnung !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Stammanlagenbezeichnung !== 'undefined')">
                            {{ submitError.response.data.Stammanlagenbezeichnung[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="Wochengueltigkeit" >Wochenprogrammgültigkeit</label>
                        <input v-model="newTeilnehmerData.Wochenprogrammgueltigkeit" type="text" id="Wochengueltigkeit"
                            name="Wochengueltigkeit"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Wochenprogrammgueltigkeit !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Wochenprogrammgueltigkeit !== 'undefined')">
                            {{ submitError.response.data.Wochenprogrammgueltigkeit[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="wochenprogrammnummer" >Wochenprogrammnummer</label>
                        <input v-model="newTeilnehmerData.Wochenprogrammnummer" type="text" id="wochenprogrammnummer"
                            name="wochenprogrammnummer"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Wochenprogrammnummer !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Wochenprogrammnummer !== 'undefined')">
                            {{ submitError.response.data.Wochenprogrammnummer[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="monatspauschale" >Monatspauschale</label>
                        <input id="monatspauschale" readonly type="text" class="form-control"
                            v-model="newTeilnehmerData.Monatspauschale">
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="nachzahltarif" >Nachzahltarif</label>
                        <input v-model="newTeilnehmerData.Nachzahltarif" type="text" id="nachzahltarif" name="nachzahltarif"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Nachzahltarif !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Nachzahltarif !== 'undefined')">
                            {{ submitError.response.data.Nachzahltarif[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="ueberziehungsgebuehr" >Überziehungsgebühr</label>
                        <select v-model="newTeilnehmerData.Ueberziehungsgebuehr" class="form-select"
                            name="ueberziehungsgebuehr" id="ueberziehungsgebuehr">
                            <option value="0">Überziehung bar</option>
                            <option value="1">Überziehung in Rechnung stellen</option>
                            <option value="2">Autorisieren</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-4" v-if="show_nutzergruppe">
                        <label for="Nutzergruppe" >Nutzergruppe</label>
                        <select value="1001" v-model="newTeilnehmerData.Nutzergruppe" class="form-select" name="nutzergruppe"
                            id="Nutzergruppe">
                            <option v-for="nutzergruppe in nutzergruppenArray" :key="nutzergruppe.nutzergruppe"
                                :value="nutzergruppe.nutzergruppe">
                                {{ nutzergruppe.name }}
                            </option>
                        </select>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="status" >Status</label>
                        <select value="0" v-model="newTeilnehmerData.Status" class="form-select" name="status" id="status">
                            <option value="0">Aktiv</option>
                            <option value="2">Nicht aktiv</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-4">
                        <label for="rabattteilnehmer" >Abrechnungsart</label>
                        <select :onchange="resetValues()" v-model="newTeilnehmerData.RabattTeilnehmer" class="form-select"
                            name="rabattteilnehmer" id="rabattteilnehmer">
                            <option value="0">Normal</option>
                            <option value="1">Bestabrechnung</option>
                            <option value="2">Vielparker</option>
                        </select>
                    </div>

                    <div class="col-12 col-md-4" v-if="newTeilnehmerData.RabattTeilnehmer == 2">
                        <label for="gutschrift" >Gutschrift</label>
                        <input v-model="newTeilnehmerData.Gutschrift" type="text" id="gutschrift" name="gutschrift"
                            :onchange="changePoint()"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Gutschrift !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Gutschrift !== 'undefined')">
                            {{ submitError.response.data.Gutschrift[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4" v-if="newTeilnehmerData.RabattTeilnehmer == 1">
                        <label for="bestpreismin" >Bestpreismin</label>
                        <input v-model="newTeilnehmerData.Bestpreismin" type="text" id="bestpreismin" name="bestpreismin"
                            :onchange="changePoint()"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Bestpreismin !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bestpreismin !== 'undefined')">
                            {{ submitError.response.data.Bestpreismin[0] }}
                        </div>
                    </div>

                    <div class="col-12 col-md-4" v-if="newTeilnehmerData.RabattTeilnehmer == 1">
                        <label for="bestpreismax" >Bestpreismax</label>
                        <input v-model="newTeilnehmerData.Bestpreismax" type="text" id="bestpreismax" name="bestpreismax"
                            :onchange="changePoint()"
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Bestpreismax !== 'undefined'),
                            }" />
                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Bestpreismax !== 'undefined')">
                            {{ submitError.response.data.Bestpreismax[0] }}
                        </div>
                    </div>

                    <!-- Firmennachzahler -->
                    <div class="col-12 col-md-4 position-relative">
                        <label for="firmennachzahler" >Firmennachzahler</label>
                        <input v-model="newTeilnehmerData.Firmennachzahler" type="text" id="firmennachzahler"
                            name="firmennachzaher" readonly
                            :class="{
                                'form-control': true,
                                'is-invalid': (submitError !== null && typeof submitError.response.data.Firmennachzahler !== 'undefined'),
                            }" />

                        <div style="position: absolute; right: 25px; top: 30px;">
                            <span v-if="newTeilnehmerData.Firmennachzahler.length == 0" data-bs-toggle="modal"
                                data-bs-target="#createNachzahler" @click="isModalVisible=true"
                                style="cursor:pointer;">
                                <i class="fas fa-plus" style="color: #a6a6a6;"></i>
                            </span>
                        </div>

                        <div class="mt-2 d-flex gap-2">
                            <button v-if="newTeilnehmerData.Firmennachzahler.length != 0" @click="deleteFirmennachzahler()"
                                id="loesche" type="button" class="btn btn-sm btn-primary"> Löschen </button>
                            <button v-if="danger" type="button" class="btn btn-sm btn-primary"
                                @click="clearFirmennachzahlerField()">Feld leeren</button>
                        </div>

                        <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Firmennachzahler !== 'undefined')">
                            {{ submitError.response.data.Firmennachzahler[0] }}
                        </div>
                    </div>

                </div> <!-- End Row -->

                <!-- Firmennachzahler Details -->
                <div v-if="newTeilnehmerData.Firmennachzahler.length != 0" class="mt-4">
                    <h3>Daten Firmennachzahler</h3>

                    <div v-if="danger" class="alert alert-danger">
                        ACHTUNG! Es existiert ein Teilnehmer mit der selben Firmennachzahlernummer!!!!!
                    </div>

                    <div class="row g-3">
                        <div class="col-12 col-md-4">
                            <label  for="anrede">Anrede</label>
                            <select id="anrede" v-model="newTeilnehmerData.Anrede" class="form-select form-control">
                                <option value="Herr">Herr</option>
                                <option value="Frau">Frau</option>
                                <option value="Divers">Divers</option>
                            </select>
                            <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response.data.Anrede !== 'undefined')" v-html="submitError.response.data.Anrede"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="name2">Vorname*</label>
                            <input id="name2" type="text" v-model="newTeilnehmerData.Name2" readonly
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Name2 !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name2 !== 'undefined')" v-html="submitError.response.data.Name2[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="name1">Name*</label>
                            <input id="name1" type="text" v-model="newTeilnehmerData.Name1" readonly
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Name1 !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Name1 !== 'undefined')" v-html="submitError.response.data.Name1[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="strasse">Straße</label>
                            <input id="strasse" type="text" v-model="newTeilnehmerData.Strasse"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Strasse !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Strasse !== 'undefined')" v-html="submitError.response.data.Strasse[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="ort">Ort</label>
                            <input id="ort" type="text" v-model="newTeilnehmerData.Ort"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Ort !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Ort !== 'undefined')" v-html="submitError.response.data.Ort[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="plz">Postleitzahl</label>
                            <input id="plz" type="text" v-model="newTeilnehmerData.Plz"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.PLZ !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.PLZ !== 'undefined')" v-html="submitError.response.data.PLZ[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="land">Land</label>
                            <select id="land" v-model="newTeilnehmerData.Land" class="form-select form-control">
                                <option value="Deutschland">Deutschland</option>
                                <option value="Belgien">Belgien</option>
                                <option value="Niederlande">Niederlande</option>
                                <option value="Luxemburg">Luxemburg</option>
                                <option value="Frankreich">Frankreich</option>
                                <option value="Österreich">Österreich</option>
                                <option value="Schweiz">Schweiz</option>
                                <option value="Italien">Italien</option>
                                <option value="Rumänien">Rumänien</option>
                                <option value="Spanien">Spanien</option>
                            </select>
                            <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response.data.Land !== 'undefined')" v-html="submitError.response.Land"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="email">E-Mail</label>
                            <input id="email" type="text" v-model="newTeilnehmerData.Email"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Email !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Email !== 'undefined')" v-html="submitError.response.data.Email[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="telefon1">Telefonnummer</label>
                            <input id="telefon1" type="text" v-model="newTeilnehmerData.Telefon1"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Telefon1 !== 'undefined'),
                                }" />
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Telefon1 !== 'undefined')" v-html="submitError.response.data.Telefon1[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="zahlart">Zahlart</label>
                            <select id="zahlart" v-model="newTeilnehmerData.Zahlart" class="form-select form-control">
                                <option value="Überweisung">Überweisung</option>
                                <option value="SEPA-Basislastschrift (CORE)">IBAN</option>
                            </select>
                        </div>

                        <div class="col-12 col-md-4" v-if="newTeilnehmerData.Zahlart === 'SEPA-Basislastschrift (CORE)'">
                            <label  for="iban">IBAN*</label>
                            <input id="iban" type="text" v-model="newTeilnehmerData.Iban"
                                data-maska="@@## **** **** **** **** **** **** **** **"
                                :class="{
                                    'form-control': true,
                                    'is-invalid': (submitError !== null && typeof submitError.response.data.Iban !== 'undefined'),
                                }" />
                            <div v-if="(errorBanking.includes('iban'))" class="invalid-feedback"> Die eingegebene Iban ist nicht korrekt. Bitte überprüfen! </div>
                            <div class="invalid-feedback" v-if="(submitError !== null && typeof submitError.response.data.Iban !== 'undefined')" v-html="submitError.response.data.Iban[0]"></div>
                        </div>

                        <div class="col-12 col-md-4">
                            <label  for="geburtsdatum">Geburtsdatum</label>
                            <VueDatePicker v-model="newTeilnehmerData.Geburtsdatum" id="geburtsdatum" text-input
                                format="dd.MM.yyyy" locale="de" :enable-time-picker="false" selectText="Auswählen"
                                cancelText="Abbrechen"
                                :input-class="`form-control ${submitError !== null && typeof submitError.response.data.Geburtsdatum !== 'undefined' ? 'is-invalid' : ''}`"
                                utc />
                            <div class="invalid-feedback d-block" v-if="(submitError !== null && typeof submitError.response.data.Geburtsdatum !== 'undefined')" v-html="submitError.response.data.Geburtsdatum[0]"></div>
                        </div>
                    </div>
                </div>

                <div style="margin:10px;  display: flex;justify-content: center;  gap:15px;">
                    <div v-if="newTeilnehmerData.Tarifnummer == 70 || newTeilnehmerData.Tarifnummer == 84" style="display: flex;align-items: center;">
                            <div class="checkbox-container">
                                <input type="checkbox" id="archiveChange" v-model="newTeilnehmerData.archiveChange" />
                                <div class="check"></div>
                            </div>
                            <span>Änderung archivieren (generiert Kündigung)</span>
                    </div>

                </div>
                <div style="display: flex;justify-content: center;flex-direction: column;align-content: center;align-items: center;">
                    <div style="width: 30%;">
                        <div style=" display: flex;justify-content: space-around;">
                            <button id="submit"
                                type="button"
                                class="btn btn-primary"
                                @click="submit()"
                                :disabled="isLoading ? true : null"
                                style="left:50%"
                            >
                                Speichern
                                <i :class="[isLoading ? 'fa-solid fa-spinner fa-spin' : '']" aria-hidden="true"></i>
                            </button>
                            <div>
                                <a :href="`/users/${newTeilnehmerData.Rechnungsempfaenger}`" class="btn btn-primary">zum Rechnungsempfänger</a>
                            </div>
                         </div>

                        <div v-if="(submitResult!=null) && (submitResult.data.status_code == 200)" style="margin-top: 5px;" class="alert alert-success">
                            <strong>Gespeichert!</strong>
                            <div v-if="submitResult.data.data.Text" style="margin-top: 5px; white-space: pre-line;">
                                {{ submitResult.data.data.Text }}
                            </div>
                        </div>
                        <div v-else-if="(submitResult!=null)&&  (submitResult.data.status_code != 200)" class="alert alert-error">
                            Daten konnten nicht gespeichert werden!
                        </div>
                        <div v-else-if="(timeOutError!=null)" class="alert alert-error">
                            {{ timeOutError }}
                        </div>

                    </div>
                </div>

            </form>
        </div>
    </div>

    <div>



    </div>


    <div class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Tarif ändern</h4>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div v-if="isModalVisible" class="modal-body">
                   <TarifSelect  @tarifValue="handleData" :value="newTeilnehmerData.Tarifnummer">

                   </TarifSelect>
                </div>
            </div>
        </div>
    </div>

</template>
